import React from 'react';
import PropTypes from 'prop-types';

import '../style/style.css';

export default function NewsBox({
  image, title, link, date,
}) {
  return (
    <div className="news-box">
      <div className="news-image">
        <img src={`${process.env.REACT_APP_API_URI}/api/image/${image}`} width="125" height="100" alt="imagem da notícia" />
      </div>
      <div>
        <a className="news-title" href={link} target="_blank" rel="noreferrer">
          {title}
        </a>
        <div className="news-date">{date}</div>
      </div>
    </div>
  );
}

NewsBox.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};
